import {
  SortOrder,
  Status,
} from 'apps/shared/scripts/__generated__/graphql.generated';

export const sortOptions = [
  { label: 'Newest', sortBy: 'createdAt', sortOrder: SortOrder.Desc },
  { label: 'Oldest', sortBy: 'createdAt', sortOrder: SortOrder.Asc },
];

export const filterOptions = [
  { label: 'All', status: null },
  { label: 'Active', status: Status.Active },
  { label: 'Published', status: Status.Published },
  { label: 'Sent', status: Status.Sent },
];
